import { render, staticRenderFns } from "./TableSearchAndPagination.vue?vue&type=template&id=06e3c0a7"
import script from "./TableSearchAndPagination.vue?vue&type=script&lang=js"
export * from "./TableSearchAndPagination.vue?vue&type=script&lang=js"
import style0 from "./TableSearchAndPagination.vue?vue&type=style&index=0&id=06e3c0a7&prod&lang=css"
import style1 from "./TableSearchAndPagination.vue?vue&type=style&index=1&id=06e3c0a7&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports